"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_1 = require("./styled");
var MinusButton_1 = tslib_1.__importDefault(require("../CircleButton/MinusButton"));
var PlusButton_1 = tslib_1.__importDefault(require("../CircleButton/PlusButton"));
function NumberPicker(_a) {
    var onIncrease = _a.onIncrease, onDecrease = _a.onDecrease, value = _a.value;
    return (react_1.default.createElement(styled_1.StyledContainer, null,
        react_1.default.createElement(MinusButton_1.default, { onClick: onDecrease }),
        react_1.default.createElement(styled_1.StyledNumberContainer, null, value),
        react_1.default.createElement(PlusButton_1.default, { onClick: onIncrease })));
}
exports.default = NumberPicker;
//# sourceMappingURL=index.js.map